// extracted by mini-css-extract-plugin
export default {"collection":"ProjectCollection_collection__mQ4NL","previewList":"ProjectCollection_previewList__AhTEP","expandedView":"ProjectCollection_expandedView__P2M2i"};